/* eslint-disable camelcase */
import React from 'react';
import {
  Box,
  Container, Divider, IconButton, styled, Typography,
} from '@mui/material';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import { getRecordMapCardElements } from './record-card-helper';

interface Props {
  record: Record<string, any>
  onClickCard: (record: Record<string, any>) => void,
  queryColumnsForm: Record<string, any>[],
  systemType: string,
}

const RecordKey = styled(Typography)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  fontFamily: 'Roboto',
  fontWeight: 400,
  fontSize: 14,
  lineHeight: '20px',
  marginTop: '5px!important',
});

const CardTitle = styled(Typography)({
  fontWeight: 700,
  fontSize: 16,
  lineHeight: '25px',
  marginTop: '0px!important',
  marginBottom: '16px!important',
}, `  .MuiOutlinedInput-input {
  cursor: pointer;
}`);

const CardRow = styled(Container)({
  display: 'flex',
  justifyContent: 'space-beteen',
  alignItems: 'center',
  paddingLeft: '0px!important',
  paddingTop: '8px!important',
});

const MapIssueCard: React.FC<Props> = ({
  record,
  onClickCard,
  queryColumnsForm,
  systemType,
}) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    onClickCard(record);
  };

  const { rowNodes, cardData } = getRecordMapCardElements(record, queryColumnsForm, systemType);

  return (
    <Box sx={{ width: '307px', margin: '0px' }}>
      <RecordKey>
        {cardData.key}
        <IconButton
          data-testid="text-editor-callback"
          color="inherit"
          size="small"
          onClick={(e) => handleClick(e)}
        >
          <OpenInFullIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </RecordKey>
      { /* @ts-ignore */ }
      <CardTitle onClick={(e) => handleClick(e)} mt={1} mb={2}>{cardData.title}</CardTitle>
      <Divider />
      <Box sx={{ marginTop: '8px!important' }}>
        {
          rowNodes.map((rowItem, index1) => (
            <CardRow key={`card-${index1 + 5}`} className="cardRow">
              <Typography ml={0} mr={1} variant="inherit">{rowItem.text}</Typography>
              { rowItem.children.map((child, index2) => (<div key={`card-${index2 + 5}`}>{child}</div>)) }
            </CardRow>
          ))
        }
      </Box>
    </Box>
  );
};

export default MapIssueCard;
